import { render, staticRenderFns } from "./TheUserProfileCreate.vue?vue&type=template&id=043fa3b0"
import script from "./TheUserProfileCreate.vue?vue&type=script&lang=js"
export * from "./TheUserProfileCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports